module.exports = __webpack_public_path__ + "img/Weapon_05.0e5c494d.png";